import { Injectable } from '@angular/core';
import { withLatestFrom, map, Observable } from 'rxjs';
import { HeatloadStore } from '../../state/heatload/heatload.store';
import { FormName, HeatLoadCalculationMethod, SuccessMessages } from '@nx-customer-apps/shared/enums';
import { ProjectStore } from '../../state/project/project.store';
import { getSelectedSourceFromGenerators } from '../../shared/utils/selected-energy-source.helper';
import { HeatGeneratorFormValue } from '@nx-customer-apps/shared/interfaces';
import { HeatGeneratorInformation } from '@nx-customer-apps/api-planning-projects';
import { HeatloadFormOptionsService } from './heatload-form-options.service';
import { ActivatedRoute } from '@angular/router';
import { HeatloadPrefillMapper } from '../../services';
import { HeatloadService } from './heatload.service';
import { AccordionService } from '../../shared/interfaces';
import { EnergySourceFormService } from '../../shared/components/energy-source';

@Injectable({
    providedIn: 'root'
})
export class EnergySourceService implements AccordionService {
    constructor(
        private heatloadService: HeatloadService,
        private prefillMapper: HeatloadPrefillMapper,
        private heatloadFormOptionsService: HeatloadFormOptionsService,
        private heatloadStore: HeatloadStore,
        private projectStore: ProjectStore,
        private route: ActivatedRoute,
        private formService: EnergySourceFormService
    ) {}

    public questions$ = this.heatloadStore.heatGenerators$.pipe(
        withLatestFrom(this.projectStore.project$, this.heatloadStore.cache$),
        map(([heatGenerators, project, cache]) => ({
            heatGenerators,
            project,
            cache
        })),
        map(state => {
            if (!state.heatGenerators) {
                return null;
            }

            const projectPrefill = this.prefillMapper.projectToEnergySourcePrefill(state.project);
            const cachePrefill = this.prefillMapper.stateToEnergySourcePrefill(state.cache?.heatingEnergySource);
            const options = this.heatloadFormOptionsService.getEnergySourceFormOptions({
                prefill: cachePrefill || projectPrefill,
                heatGenerators: state.heatGenerators
            });
            return this.formService.getEnergySourceQuestions(options);
        })
    );

    public getSuccessMessage(generators: HeatGeneratorInformation[], formValue: HeatGeneratorFormValue): string {
        const energySource = getSelectedSourceFromGenerators(generators, formValue.heatGenerator, formValue.specificEnergySource);
        return `${SuccessMessages.HeatingEnergySource}.${energySource.type}`;
    }

    public isExpanded$ = this.isSubmitedCalculationMethodSameValue$();

    public isSubmitedCalculationMethodSameValue$(): Observable<boolean> {
        return this.heatloadStore.sameValueSubmited$.pipe(
            map(
                form =>
                    form?.formName === FormName.CalculationMethod &&
                    form.value.methods.standardMethod === HeatLoadCalculationMethod.Consumption
            )
        );
    }
}
